// removed by extract-text-webpack-plugin
module.exports = {"setupSider":"Sider__setupSider___RVNsl","siderTitle":"Sider__siderTitle___2d6BO","menuItem":"Sider__menuItem___2YuQ0","itemLink":"Sider__itemLink___2b8nx","left-nav-item":"Sider__left-nav-item___2CJyT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/Sider/Sider.less
// module id = 1932
// module chunks = 3